import styled from 'styled-components'


const MyDiv = styled.div`
.tab-header-combined {
  align-items: center;
  flex-wrap: nowrap;
  gap: 16px;
  overflow-x: auto;


  .tab-list-container {
    flex-grow: 1;
    overflow-x: auto;
  }

  .chakra-tabs__tab {
    flex-shrink: 0;
  }
}

  .chakra-tabs__tab[aria-selected="true"] {
    background: #006838;
    color: white;
  }


  .tab-list-container::-webkit-scrollbar {
    height: 2px; 
  }

  .tab-list-container::-webkit-scrollbar-track {
    background: transparent; 
  }

  .tab-list-container::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 1px; 
  }

  .tab-list-container::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .tab-list-container {
    scrollbar-width: thin; 
    scrollbar-color: #888 transparent; 
  }

  .tab-list-container {
    scrollbar-width: none;
  }
  .tab-list-container::-webkit-scrollbar {
    display: none;
  }
  .tab-list-container:hover {
    scrollbar-width: thin;
  }
  .tab-list-container:hover::-webkit-scrollbar {
    display: block;
  }
`
export default MyDiv